import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import player from "lottie-web";
import { LottieModule } from "ngx-lottie";
import { KwikUIAnimationPlayerLottieComponent } from "./lottie.component";

// Note we need a separate function as it's required
// by the AOT compiler.
export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [KwikUIAnimationPlayerLottieComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LottieModule.forRoot({ player: playerFactory })
  ],
  exports: [KwikUIAnimationPlayerLottieComponent]
})
export class KwikUIAnimationPlayerLottieModule {}
